class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.handleNavClick = this.handleNavClick.bind(this);
    this.handleNavSwitch = this.handleNavSwitch.bind(this);

    this.handleMegaEnter = this.handleMegaEnter.bind(this);
    this.handleMegaLeave = this.handleMegaLeave.bind(this);
    this.handleMegaBackgroundHover = this.handleMegaBackgroundHover.bind(this);

    this.handleVeilEnter = this.handleVeilEnter.bind(this);
    this.handleNavItemEnter = this.handleNavItemEnter.bind(this);

    this.handleMobileToggle = this.handleMobileToggle.bind(this);
    this.handleMobilePanelClick = this.handleMobilePanelClick.bind(this);

    this.navHoverTimeout = null;
    this.currentMegaItem = null;
    this.megaLeaveTimeout = null;

    this.isIOS = this.isIOS.bind(this);

    this.activeOverlayType = null;
  }

  isIOS() {
    if (typeof navigator === "undefined") return false;
    return /iP(hone|od|ad)/.test(navigator.userAgent);
  }

  connectedCallback() {
    this.headerEl = this;
    this.topTierEl = this.querySelector("[data-header-top]");

    this.veilEl = document.querySelector("[data-header-veil]");
    this.intlMenu = document.querySelector(".intl-menu");
    this.intlMenuMobile = document.querySelector(
      ".intl-menu__mobile .intl-menu"
    );
    this.intlTrigger =
      this.querySelector(".js-intl-menu-trigger") ||
      document.querySelector(".js-intl-menu-trigger");

    this.cartEl =
      document.querySelector("[data-cart-panel]") ||
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector("cart-drawer");

    if (this.shellEl && this.isIOS()) {
      this.shellEl.classList.remove("js-header-inverted");
      this.shellEl.classList.add("bg-cloud");
    }

    if (this.topTierEl) {
      const rect = this.topTierEl.getBoundingClientRect();
      this.initialTopHeight = rect.height || 30;

      window.addEventListener("scroll", this.handleScroll, { passive: true });
      this.addEventListener("click", this.handleClick);

      this.handleScroll();
    }

    this.navPanels = this.querySelectorAll("[data-nav-panel]");
    this.navTriggers = this.querySelectorAll("[data-nav-trigger]");
    this.navSwitchers = this.querySelectorAll("[data-switch-nav]");

    if (this.navPanels.length && this.navTriggers.length) {
      this.navTriggers.forEach((trigger) => {
        trigger.addEventListener("click", this.handleNavClick);
      });
    }

    if (this.navSwitchers && this.navSwitchers.length) {
      this.navSwitchers.forEach((btn) => {
        btn.addEventListener("click", this.handleNavSwitch);
      });
    }

    this.navItems = this.querySelectorAll("[data-nav-item]");
    if (this.navItems.length) {
      this.navItems.forEach((item) => {
        item.addEventListener("mouseenter", this.handleNavItemEnter);
      });
    }

    this.megaItems = this.querySelectorAll(
      "[data-nav-item][data-has-menu='true']"
    );
    if (this.megaItems.length) {
      this.megaItems.forEach((item) => {
        item.addEventListener("mouseenter", this.handleMegaEnter);
        item.addEventListener("mouseleave", this.handleMegaLeave);
      });
    }

    if (this.veilEl) {
      this.veilEl.addEventListener("mouseenter", this.handleVeilEnter);
      this.veilEl.addEventListener("click", this.handleVeilEnter);
      this.hideVeil(false);
    }

    const megaMenus = this.querySelectorAll("[data-nav-menu]");
    megaMenus.forEach((menu) => {
      menu.style.opacity = menu.style.opacity || "0";
      menu.style.visibility = menu.style.visibility || "hidden";
      menu.style.pointerEvents = menu.style.pointerEvents || "none";
      menu.style.transition = "none";

      menu.addEventListener("mouseover", this.handleMegaBackgroundHover);
    });
    this.megaMenus = megaMenus;

    this.mobileNav = this.querySelector(".js-mobile-nav");
    this.mobileToggleButtons = this.querySelectorAll(".js-menu-toggle");
    this.mobilePanels = this.querySelectorAll("[data-mobile-panel]");
    this.mobilePanelTriggers = this.querySelectorAll("[data-mobile-trigger]");

    if (this.mobileNav && this.mobileToggleButtons.length) {
      this.mobileToggleButtons.forEach((btn) => {
        btn.addEventListener("click", this.handleMobileToggle);
      });
      this.setMobileNavOpen(false, true);
    }

    if (this.mobilePanels.length && this.mobilePanelTriggers.length) {
      this.mobilePanelTriggers.forEach((btn) => {
        btn.addEventListener("click", this.handleMobilePanelClick);
      });
      this.setActiveMobilePanel("shop");
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    this.removeEventListener("click", this.handleClick);

    if (this.navTriggers && this.navTriggers.length) {
      this.navTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", this.handleNavClick);
      });
    }

    if (this.navSwitchers && this.navSwitchers.length) {
      this.navSwitchers.forEach((btn) => {
        btn.removeEventListener("click", this.handleNavSwitch);
      });
    }

    if (this.navItems && this.navItems.length) {
      this.navItems.forEach((item) => {
        item.removeEventListener("mouseenter", this.handleNavItemEnter);
      });
    }

    if (this.megaItems && this.megaItems.length) {
      this.megaItems.forEach((item) => {
        item.removeEventListener("mouseenter", this.handleMegaEnter);
        item.removeEventListener("mouseleave", this.handleMegaLeave);
      });
    }

    if (this.veilEl) {
      this.veilEl.removeEventListener("mouseenter", this.handleVeilEnter);
      this.veilEl.removeEventListener("click", this.handleVeilEnter);
    }

    if (this.navHoverTimeout) {
      clearTimeout(this.navHoverTimeout);
      this.navHoverTimeout = null;
    }

    if (this.megaLeaveTimeout) {
      clearTimeout(this.megaLeaveTimeout);
      this.megaLeaveTimeout = null;
    }

    if (this.megaMenus && this.megaMenus.length) {
      this.megaMenus.forEach((menu) => {
        menu.removeEventListener("mouseover", this.handleMegaBackgroundHover);
      });
    }
  }

  handleScroll() {
    if (!this.topTierEl) return;

    const y = window.scrollY || window.pageYOffset || 0;

    if (y > 30) {
      this.topTierEl.style.height = "0px";
      this.headerEl.classList.add("js-header-scrolled");
    } else {
      const h = this.initialTopHeight <= 30 ? 30 : this.initialTopHeight;
      this.topTierEl.style.height = `${h}px`;
      this.headerEl.classList.remove("js-header-scrolled");
    }
  }

  handleClick(event) {
    const button = event.target.closest("button");
    if (!button) return;

    if (button.classList.contains("js-gated-menu-open")) {
      const menu = this.querySelector(".js-gated-menu");
      if (!menu) return;

      button.classList.toggle("js-gated-menu-open--active");
      menu.classList.toggle("js-gated-menu--active");
    }

    if (button.classList.contains("js-intl-menu-trigger")) {
      event.preventDefault();
      event.stopPropagation();
      this.toggleIntlMenu();
      return;
    }

    if (button.hasAttribute("data-cart-toggle")) {
      event.preventDefault();
      event.stopPropagation();
      this.toggleCartOverlay();
      return;
    }
  }

  handleMegaBackgroundHover(event) {
    if (window.innerWidth < 1024) return;
    if (this.activeOverlayType !== "mega") return;

    const menu = event.currentTarget;
    const content = menu.querySelector("[data-menu]");
    if (!content) return;

    if (!content.contains(event.target)) {
      this.closeMegaMenu(true);
    }
  }

  handleNavClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const trigger = event.currentTarget;
    const target = trigger.dataset.navTrigger;
    if (!target) return;

    this.setActiveNav(target);
  }

  handleNavSwitch(event) {
    event.preventDefault();
    event.stopPropagation();

    const btn = event.currentTarget;
    const target = btn.dataset.switchNav;
    if (!target) return;

    this.setActiveNav(target);
  }

  setActiveNav(name) {
    if (!this.navPanels || !this.navPanels.length) return;

    this.closeMegaMenu(false);

    this.navPanels.forEach((panel) => {
      const panelName = panel.dataset.navPanel;
      const isActive = panelName === name;
      panel.classList.toggle("hidden", !isActive);
      panel.classList.toggle("flex", isActive);
    });

    if (this.navTriggers && this.navTriggers.length) {
      this.navTriggers.forEach((trigger) => {
        const isActive = trigger.dataset.navTrigger === name;

        trigger.setAttribute("aria-current", isActive ? "page" : "false");

        if (isActive) {
          trigger.classList.add("shadow-[inset_0_-1px_0_0_rgba(0,0,0,1)]");
        } else {
          trigger.classList.remove("shadow-[inset_0_-1px_0_0_rgba(0,0,0,1)]");
        }
      });
    }

    const contentCta = this.querySelector("[data-member-content-cta]");
    if (contentCta) {
      if (name === "content") {
        contentCta.classList.remove(
          "opacity-0",
          "invisible",
          "pointer-events-none"
        );
        contentCta.classList.add("opacity-100", "visible");
      } else {
        contentCta.classList.remove("opacity-100", "visible");
        contentCta.classList.add(
          "opacity-0",
          "invisible",
          "pointer-events-none"
        );
      }
    }
  }

  handleNavItemEnter(event) {
    const item = event.currentTarget;
    const hasMenu = item.hasAttribute("data-has-menu");

    if (!hasMenu) {
      if (this.activeOverlayType === "mega") {
        this.closeMegaMenu(true);
      }
      if (this.activeOverlayType === "intl") {
        this.closeIntlMenu(true);
      }
      if (this.activeOverlayType === "cart") {
        this.closeCartOverlay(true);
      }
    }
  }

  handleMegaEnter(event) {
    const item = event.currentTarget;
    const menu = item.querySelector("[data-nav-menu]");
    if (!menu) return;

    if (this.megaLeaveTimeout) {
      clearTimeout(this.megaLeaveTimeout);
      this.megaLeaveTimeout = null;
    }

    const isMegaActive = this.activeOverlayType === "mega";
    const isSameItem = isMegaActive && this.currentMegaItem === item;
    const hasOtherOpen =
      this.activeOverlayType && this.activeOverlayType !== "mega";

    if (!this.activeOverlayType) {
      this.openMegaMenu(menu, true);
    } else if (isMegaActive && !isSameItem) {
      this.switchMegaMenu(menu);
    } else if (hasOtherOpen) {
      this.closeCurrentOverlayInstant();
      this.openMegaMenu(menu, false);
    }

    this.currentMegaItem = item;
  }

  handleMegaLeave() {
    if (this.megaLeaveTimeout) {
      clearTimeout(this.megaLeaveTimeout);
      this.megaLeaveTimeout = null;
    }

    this.megaLeaveTimeout = setTimeout(() => {
      this.closeMegaMenu(true);
      this.megaLeaveTimeout = null;
    }, 120);
  }

  handleVeilEnter() {
    this.closeAllOverlays(true);
  }

  showVeil(animate) {
    if (!this.veilEl) return;

    this.veilEl.style.opacity = "1";
    this.veilEl.style.visibility = "visible";
    this.veilEl.style.pointerEvents = "auto";
  }

  hideVeil(animate) {
    if (!this.veilEl) return;

    this.veilEl.style.opacity = "0";
    this.veilEl.style.visibility = "hidden";
    this.veilEl.style.pointerEvents = "none";
  }

  showMenu(menu, animate) {
    if (!menu) return;

    menu.style.transition = animate ? "opacity 0.25s ease" : "none";
    menu.style.opacity = "1";
    menu.style.visibility = "visible";
    menu.style.pointerEvents = "auto";
  }

  hideMenu(menu) {
    if (!menu) return;

    menu.style.transition = "none";
    menu.style.opacity = "0";
    menu.style.visibility = "hidden";
    menu.style.pointerEvents = "none";
  }

  toggleIntlMenu() {
    const isMobile = window.innerWidth < 1024;

    if (isMobile && this.intlMenuMobile) {
      const isVisible = this.intlMenuMobile.style.visibility === "visible";

      if (isVisible) {
        this.intlMenuMobile.style.opacity = "0";
        this.intlMenuMobile.style.visibility = "hidden";
        this.intlMenuMobile.style.pointerEvents = "none";
        document.body.style.overflow = "auto";
        if (this.activeOverlayType === "intl") {
          this.activeOverlayType = null;
        }
      } else {
        if (
          this.mobileNav &&
          this.mobileNav.getAttribute("data-open") === "true" &&
          typeof this.setMobileNavOpen === "function"
        ) {
          this.setMobileNavOpen(false, true);
        }

        if (this.activeOverlayType === "cart") {
          this.closeCartOverlay(false);
        }

        this.intlMenuMobile.style.opacity = "1";
        this.intlMenuMobile.style.visibility = "visible";
        this.intlMenuMobile.style.pointerEvents = "auto";

        document.body.style.overflow = "hidden";
        this.activeOverlayType = "intl";
      }

      return;
    }

    if (!this.intlMenu) return;

    const isOpen = this.activeOverlayType === "intl";
    const hasOtherOpen =
      this.activeOverlayType && this.activeOverlayType !== "intl";

    if (isOpen) {
      this.closeIntlMenu(true);
      this.activeOverlayType = null;
      return;
    }

    if (hasOtherOpen) {
      this.closeCurrentOverlayInstant();
      this.openIntlMenu(false);
    } else {
      this.openIntlMenu(true);
    }

    this.activeOverlayType = "intl";
  }

  openIntlMenu(animate) {
    if (!this.intlMenu) return;

    this.showMenu(this.intlMenu, animate);
    if (this.intlTrigger) {
      this.intlTrigger.classList.add("active");
    }
    this.showVeil(animate);
  }

  closeIntlMenu(animate) {
    if (!this.intlMenu) return;

    this.hideMenu(this.intlMenu);
    if (this.intlTrigger) {
      this.intlTrigger.classList.remove("active");
    }

    if (this.activeOverlayType === "intl") {
      this.hideVeil(animate);
      this.activeOverlayType = null;
    }
  }

  openMegaMenu(menu, animate) {
    this.showMenu(menu, animate);
    this.showVeil(animate);
    this.activeOverlayType = "mega";
  }

  switchMegaMenu(menu) {
    if (this.currentMegaItem) {
      const prevMenu = this.currentMegaItem.querySelector("[data-nav-menu]");
      if (prevMenu && prevMenu !== menu) {
        this.hideMenu(prevMenu);
      }
    }
    this.showMenu(menu, false);
    this.activeOverlayType = "mega";
  }

  closeMegaMenu(animate) {
    if (this.currentMegaItem) {
      const menu = this.currentMegaItem.querySelector("[data-nav-menu]");
      if (menu) {
        this.hideMenu(menu);
      }
    }

    if (this.activeOverlayType === "mega") {
      this.hideVeil(animate);
      this.activeOverlayType = null;
    }

    this.currentMegaItem = null;
  }

  openCartOverlayFromEvent() {
    if (!this.cartEl) {
      this.cartEl =
        document.querySelector("[data-cart-panel]") ||
        document.querySelector("[data-cart-drawer]") ||
        document.querySelector("cart-drawer");
    }

    if (!this.cartEl) return;

    const isDesktop = window.innerWidth >= 1024;

    if (!isDesktop && this.intlMenuMobile) {
      this.intlMenuMobile.style.opacity = "0";
      this.intlMenuMobile.style.visibility = "hidden";
      this.intlMenuMobile.style.pointerEvents = "none";

      if (this.activeOverlayType === "intl") {
        this.activeOverlayType = null;
      }
    }

    const mobileWasOpen =
      this.mobileNav && this.mobileNav.getAttribute("data-open") === "true";

    if (mobileWasOpen && typeof this.setMobileNavOpen === "function") {
      this.setMobileNavOpen(false, true);
    }

    const hasOtherOpen =
      this.activeOverlayType && this.activeOverlayType !== "cart";

    const animateIn = isDesktop && !mobileWasOpen;
    const fromIntl = this.activeOverlayType === "intl";

    if (!this.activeOverlayType) {
      this.showMenu(this.cartEl, animateIn);
      this.showVeil(animateIn);
    } else if (hasOtherOpen) {
      this.closeCurrentOverlayInstant();
      const animate = isDesktop && !fromIntl;
      this.showMenu(this.cartEl, animate);
      this.showVeil(animate);
    } else {
      this.showMenu(this.cartEl, isDesktop);
      this.showVeil(isDesktop);
    }

    if (!isDesktop) {
      document.body.style.overflow = "hidden";
    }

    this.activeOverlayType = "cart";
  }

  closeCartOverlay(animate) {
    if (!this.cartEl) return;

    this.hideMenu(this.cartEl);

    if (this.activeOverlayType === "cart") {
      const isDesktop = window.innerWidth >= 1024;

      if (isDesktop) {
        this.hideVeil(animate);
      } else {
        document.body.style.overflow = "auto";
      }

      this.activeOverlayType = null;
    }
  }

  closeCurrentOverlayInstant() {
    if (!this.activeOverlayType) return;

    if (this.activeOverlayType === "intl") {
      if (this.intlMenu) this.hideMenu(this.intlMenu);
      if (this.intlTrigger) {
        this.intlTrigger.classList.remove("active");
      }
    } else if (this.activeOverlayType === "mega") {
      if (this.currentMegaItem) {
        const menu = this.currentMegaItem.querySelector("[data-nav-menu]");
        if (menu) this.hideMenu(menu);
      }
      this.currentMegaItem = null;
    } else if (this.activeOverlayType === "cart") {
      if (this.cartEl) this.hideMenu(this.cartEl);
    }

    this.activeOverlayType = null;
  }

  closeAllOverlays(animateVeil) {
    if (this.activeOverlayType === "intl") {
      this.closeIntlMenu(animateVeil);
    } else if (this.activeOverlayType === "mega") {
      this.closeMegaMenu(animateVeil);
    } else if (this.activeOverlayType === "cart") {
      this.closeCartOverlay(animateVeil);
    } else {
      this.hideVeil(animateVeil);
    }
  }

  handleMobileToggle(event) {
    event.preventDefault();
    if (!this.mobileNav) return;

    const isOpen = this.mobileNav.getAttribute("data-open") === "true";
    this.setMobileNavOpen(!isOpen, false);
  }

  setMobileNavOpen(isOpen, immediate = false) {
    if (!this.mobileNav) return;

    if (isOpen && this.activeOverlayType === "cart") {
      this.closeCartOverlay(false);
    }

    if (isOpen && this.intlMenuMobile) {
      this.intlMenuMobile.style.opacity = "0";
      this.intlMenuMobile.style.visibility = "hidden";
      this.intlMenuMobile.style.pointerEvents = "none";

      if (this.activeOverlayType === "intl") {
        this.activeOverlayType = null;
      }
    }

    this.mobileNav.setAttribute("data-open", isOpen ? "true" : "false");

    if (immediate) {
      const prevTransition = this.mobileNav.style.transition || "";
      this.mobileNav.style.transition = "none";
      this.mobileNav.style.opacity = isOpen ? "1" : "0";
      this.mobileNav.style.visibility = isOpen ? "visible" : "hidden";
      this.mobileNav.style.pointerEvents = isOpen ? "auto" : "none";
      void this.mobileNav.offsetHeight;
      this.mobileNav.style.transition = prevTransition;
    } else {
      this.mobileNav.style.opacity = isOpen ? "1" : "0";
      this.mobileNav.style.visibility = isOpen ? "visible" : "hidden";
      this.mobileNav.style.pointerEvents = isOpen ? "auto" : "none";
    }

    if (isOpen) {
      document.body.style.overflow = "hidden";

      const event = new CustomEvent("mobileNavOpened");
      document.dispatchEvent(event);
    } else {
      document.body.style.overflow = "auto";

      const intlMenuMobile = document.querySelector(
        ".intl-menu__mobile .intl-menu"
      );
      if (intlMenuMobile) {
        intlMenuMobile.classList.remove("active");
      }
    }

    if (!this.mobileToggleButtons) return;

    this.mobileToggleButtons.forEach((btn) => {
      const spans = btn.querySelectorAll("span");
      if (spans.length < 2) return;

      const menuSpan = spans[0];
      const closeSpan = spans[1];

      if (isOpen) {
        menuSpan.style.display = "none";
        closeSpan.style.display = "inline";
      } else {
        menuSpan.style.display = "inline";
        closeSpan.style.display = "none";
      }
    });
  }

  handleMobilePanelClick(event) {
    const trigger = event.currentTarget;
    const name = trigger.dataset.mobileTrigger;
    if (!name) return;
    this.setActiveMobilePanel(name);
  }

  setActiveMobilePanel(name) {
    if (!this.mobilePanels || !this.mobilePanelTriggers) return;

    this.mobilePanels.forEach((panel) => {
      const isActive = panel.dataset.mobilePanel === name;
      panel.style.display = isActive ? "block" : "none";
    });

    this.mobilePanelTriggers.forEach((btn) => {
      const isActive = btn.dataset.mobileTrigger === name;
      btn.style.borderBottomWidth = "1px";
      btn.style.borderBottomStyle = "solid";
      btn.style.borderBottomColor = isActive ? "#000" : "transparent";
    });
  }

  toggleCartOverlay() {
    if (!this.cartEl) {
      this.cartEl =
        document.querySelector("[data-cart-panel]") ||
        document.querySelector("[data-cart-drawer]") ||
        document.querySelector("cart-drawer");
    }

    if (!this.cartEl) return;

    const isCartActive = this.activeOverlayType === "cart";
    const hasOtherOpen =
      this.activeOverlayType && this.activeOverlayType !== "cart";

    if (isCartActive) {
      this.closeCartOverlay(true);
      return;
    }

    const mobileWasOpen =
      this.mobileNav && this.mobileNav.getAttribute("data-open") === "true";

    if (mobileWasOpen) {
      this.setMobileNavOpen(false, true);
    }

    const isDesktop = window.innerWidth >= 1024;
    const animateIn = isDesktop && !mobileWasOpen;
    const fromIntl = this.activeOverlayType === "intl";

    if (!this.activeOverlayType) {
      this.showMenu(this.cartEl, animateIn);
      this.showVeil(animateIn);
    } else if (hasOtherOpen) {
      this.closeCurrentOverlayInstant();
      const animate = isDesktop && !fromIntl;
      this.showMenu(this.cartEl, animate);
      this.showVeil(animate);
    }

    if (!isDesktop) {
      document.body.style.overflow = "hidden";
    }

    this.activeOverlayType = "cart";
  }
}

if (!customElements.get("site-header")) {
  customElements.define("site-header", SiteHeader);
}

(() => {
  document.addEventListener("click", (e) => {
    const button = e.target.closest("button.nav-menu-item");
    if (!button) return;

    const iconSpan = button.querySelector("span");
    const panel = button.nextElementSibling;
    if (!panel) return;

    const isOpen = panel.getAttribute("data-open") === "true";

    if (isOpen) {
      panel.setAttribute("data-open", "false");
      panel.style.display = "none";
      if (iconSpan) {
        iconSpan.style.transform = "rotate(0deg)";
      }
    } else {
      panel.setAttribute("data-open", "true");
      panel.style.display = "block";
      if (iconSpan) {
        iconSpan.style.transform = "rotate(180deg)";
      }
    }
  });

  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".cart-close");
    if (!closeBtn) return;

    e.preventDefault();

    const header = document.querySelector("site-header");
    if (header && typeof header.closeCartOverlay === "function") {
      header.closeCartOverlay(true);
    }
  });

  document.addEventListener("cartOpened", () => {
    const header = document.querySelector("site-header");
    if (!header) {
      document.body.style.overflow = "auto";
      return;
    }

    if (typeof header.setMobileNavOpen === "function") {
      header.setMobileNavOpen(false, true);
    }

    if (
      typeof header.openCartOverlayFromEvent === "function" &&
      typeof header.closeCartOverlay === "function"
    ) {
      if (header.activeOverlayType === "cart") {
        header.closeCartOverlay(true);
      } else {
        header.openCartOverlayFromEvent();
      }
    } else {
      document.body.style.overflow = "auto";
    }
  });
})();
